import { useEffect, useRef } from "react";
import { ChevronLeft, ChevronRight, X } from "lucide-react";
import { srcSet, bestSrc } from "@/lib/api";

export const Lightbox = ({ images, index, onIndex, onClose }) => {
  const touch = useRef(null);
  const n = images.length;
  const img = images[index];

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onIndex((index + 1) % n);
      if (e.key === "ArrowLeft") onIndex((index - 1 + n) % n);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [index, n, onClose, onIndex]);

  useEffect(() => {
    [images[(index + 1) % n], images[(index - 1 + n) % n]].forEach((p) => {
      if (!p) return;
      const pre = new Image();
      pre.sizes = "100vw";
      pre.srcset = srcSet(p);
      pre.src = bestSrc(p, 2560);
    });
  }, [index, images, n]);

  if (!img) return null;

  const onTouchEnd = (e) => {
    if (touch.current == null) return;
    const dx = e.changedTouches[0].clientX - touch.current;
    if (Math.abs(dx) > 50) onIndex(dx < 0 ? (index + 1) % n : (index - 1 + n) % n);
    touch.current = null;
  };

  return (
    <div
      className="jt-lb"
      role="dialog"
      aria-label="Image viewer"
      data-testid="lightbox"
      onTouchStart={(e) => (touch.current = e.touches[0].clientX)}
      onTouchEnd={onTouchEnd}
    >
      <div className="jt-lb__stage" onClick={onClose}>
        <img
          key={img.media_id}
          className="jt-lb__img"
          src={bestSrc(img, 2560)}
          srcSet={srcSet(img)}
          sizes="100vw"
          alt={img.alt || ""}
          onClick={(e) => e.stopPropagation()}
          data-testid="lightbox-image"
        />
      </div>
      <button type="button" className="jt-lb__btn jt-lb__close" onClick={onClose} aria-label="Close" data-testid="lightbox-close">
        <X size={22} />
      </button>
      {n > 1 && (
        <>
          <button type="button" className="jt-lb__btn jt-lb__prev" onClick={() => onIndex((index - 1 + n) % n)} aria-label="Previous" data-testid="lightbox-prev">
            <ChevronLeft size={30} strokeWidth={1.5} />
          </button>
          <button type="button" className="jt-lb__btn jt-lb__next" onClick={() => onIndex((index + 1) % n)} aria-label="Next" data-testid="lightbox-next">
            <ChevronRight size={30} strokeWidth={1.5} />
          </button>
        </>
      )}
    </div>
  );
};
